import {styled} from '@esgi/ui/theme';
import {Text} from '@esgi/ui/typography';

export const InfoBlockLabel = styled(Text, {
	width: 'max-content',
	textWrap: 'no-wrap',
});
